// File Metadata:
// Filename: PendingApprovals.js
// Version: 1.00
// Created: 2025-03-23 01:04:36
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { List, ListItem, ListItemText, Chip } from '@mui/material'
import { format } from 'date-fns'
import { useNavigate } from 'react-router-dom'

const PendingApprovals = ({ receptions }) => {
    const navigate = useNavigate()
    const pendingReceptions = Object.values(receptions?.entities || {})
        .filter(r => r.qualityStatus === 'PENDING_APPROVAL')
        .sort((a, b) => new Date(b.deliveryDate) - new Date(a.deliveryDate))

    return (
        <List>
            {pendingReceptions.map(reception => (
                <ListItem 
                    key={reception.id}
                    button
                    onClick={() => navigate(`/dash/receptions/${reception.id}`)}
                >
                    <ListItemText
                        primary={`${reception.vendorName} - TU ${reception.tourNumber}`}
                        secondary={format(new Date(reception.deliveryDate), 'dd-MM-yyyy')}
                    />
                    <Chip 
                        label="Pending"
                        color="warning"
                        size="small"
                    />
                </ListItem>
            ))}
        </List>
    )
}

export default PendingApprovals
